/**
 * Harvest Mate - OEM Connection API
 *
 * Contact: servicedesk@clevvi.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { FieldLink } from '../model/field-link';
// @ts-ignore
import { FieldsList } from '../model/fields-list';
// @ts-ignore
import { LinkFieldRequest } from '../model/link-field-request';
// @ts-ignore
import { Provider } from '../model/provider';
// @ts-ignore
import { UnlinkFieldResponse } from '../model/unlink-field-response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class OemFieldsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Link an OEM field to a Harvest Mate block.
     * Inserts (or idempotently re-points) a row in &#x60;oem_field_links&#x60; joining &#x60;(provider, oem_field_id)&#x60; to the requested &#x60;block_id&#x60;. The unique constraint on &#x60;(provider, oem_field_id)&#x60; prevents two contractors from mapping the same OEM field to different blocks.  Enforces that the caller has a &#x60;harvester_crop_assignments&#x60; row joining a group they own to &#x60;block_id&#x60; — cross-contractor mapping is rejected with 403 &#x60;block_not_assigned&#x60;.  Triggers a synchronous replay of unresolved &#x60;oem_unlinked_events&#x60; for that &#x60;(provider, oem_field_id, contractor_id)&#x60;. The 201 response body carries &#x60;replayed_count&#x60; so the FE counter banner can refresh in the same request cycle (SRA003-116).  DB-only — works for both providers regardless of the CNH base URL gate that affects the &#x60;GET fields&#x60; endpoint. 
     * @endpoint post /oem-connection/{provider}/fields/{oem_field_id}/link
     * @param provider OEM provider key.
     * @param oemFieldId OEM-issued field identifier.
     * @param linkFieldRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public linkOemField(provider: Provider, oemFieldId: string, linkFieldRequest: LinkFieldRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FieldLink>;
    public linkOemField(provider: Provider, oemFieldId: string, linkFieldRequest: LinkFieldRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FieldLink>>;
    public linkOemField(provider: Provider, oemFieldId: string, linkFieldRequest: LinkFieldRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FieldLink>>;
    public linkOemField(provider: Provider, oemFieldId: string, linkFieldRequest: LinkFieldRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (provider === null || provider === undefined) {
            throw new Error('Required parameter provider was null or undefined when calling linkOemField.');
        }
        if (oemFieldId === null || oemFieldId === undefined) {
            throw new Error('Required parameter oemFieldId was null or undefined when calling linkOemField.');
        }
        if (linkFieldRequest === null || linkFieldRequest === undefined) {
            throw new Error('Required parameter linkFieldRequest was null or undefined when calling linkOemField.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cognito) required
        localVarHeaders = this.configuration.addCredentialToHeaders('cognito', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/oem-connection/${this.configuration.encodeParam({name: "provider", value: provider, in: "path", style: "simple", explode: false, dataType: "Provider", dataFormat: undefined})}/fields/${this.configuration.encodeParam({name: "oemFieldId", value: oemFieldId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/link`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FieldLink>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: linkFieldRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List OEM fields visible via the contractor\&#39;s connected org.
     * Returns the OEM-side fields enumerable through the contractor\&#39;s active OAuth connection. Deere sources from &#x60;GET .../organizations/{orgId}/fields&#x60;; CNH sources from the company overview &#x60;GET /v1/companies/{companyId}/overview&#x60;, flattening its grower→farm→field tree (SRA003-433). Each entry carries &#x60;linked_block_id&#x60; when the contractor has already linked that field to a Harvest Mate block via the POST endpoint below.  A connected org with no fields yet (Deere 404 / empty CNH overview) returns 200 with an empty array. CNH carries no per-field area, so &#x60;area_ha&#x60; is null for CNH entries. 
     * @endpoint get /oem-connection/{provider}/fields
     * @param provider OEM provider key.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listOemFields(provider: Provider, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FieldsList>;
    public listOemFields(provider: Provider, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FieldsList>>;
    public listOemFields(provider: Provider, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FieldsList>>;
    public listOemFields(provider: Provider, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (provider === null || provider === undefined) {
            throw new Error('Required parameter provider was null or undefined when calling listOemFields.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cognito) required
        localVarHeaders = this.configuration.addCredentialToHeaders('cognito', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/oem-connection/${this.configuration.encodeParam({name: "provider", value: provider, in: "path", style: "simple", explode: false, dataType: "Provider", dataFormat: undefined})}/fields`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FieldsList>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Unlink an OEM field (soft-archive).
     * Soft-archives the active &#x60;oem_field_links&#x60; row by setting &#x60;status&#x3D;\&#39;archived\&#39;&#x60; rather than deleting it. Per design spec §11 (\&quot;no-one-way-doors\&quot;): preserves attribution history; existing &#x60;harvester_field_operation_summaries&#x60; rows already carry resolved &#x60;block_id&#x60;/&#x60;grower_id&#x60; and are NOT retroactively re-parked.  Note: design spec §5.1 calls for HTTP 204; the implementation returns 200 with a typed body due to the &#x60;LambdaHandler.API_GATEWAY&#x60; envelope shape (HTTP API v2 default status). Reconciliation pending architect review. 
     * @endpoint delete /oem-connection/{provider}/fields/{oem_field_id}/link
     * @param provider OEM provider key.
     * @param oemFieldId OEM-issued field identifier.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public unlinkOemField(provider: Provider, oemFieldId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<UnlinkFieldResponse>;
    public unlinkOemField(provider: Provider, oemFieldId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<UnlinkFieldResponse>>;
    public unlinkOemField(provider: Provider, oemFieldId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<UnlinkFieldResponse>>;
    public unlinkOemField(provider: Provider, oemFieldId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (provider === null || provider === undefined) {
            throw new Error('Required parameter provider was null or undefined when calling unlinkOemField.');
        }
        if (oemFieldId === null || oemFieldId === undefined) {
            throw new Error('Required parameter oemFieldId was null or undefined when calling unlinkOemField.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cognito) required
        localVarHeaders = this.configuration.addCredentialToHeaders('cognito', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/oem-connection/${this.configuration.encodeParam({name: "provider", value: provider, in: "path", style: "simple", explode: false, dataType: "Provider", dataFormat: undefined})}/fields/${this.configuration.encodeParam({name: "oemFieldId", value: oemFieldId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/link`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<UnlinkFieldResponse>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
